import { useEffect, useState } from "react";

/**
 * Visibility-aware tick. Pauses interval when tab hidden (battery on iPhone).
 * Re-syncs immediately when tab returns.
 */
export function useNow(intervalMs = 15_000): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    let id: ReturnType<typeof setInterval> | null = null;

    function start() {
      if (id) return;
      setNow(new Date());
      id = setInterval(() => setNow(new Date()), intervalMs);
    }
    function stop() {
      if (id) {
        clearInterval(id);
        id = null;
      }
    }
    function onVisibility() {
      if (document.hidden) stop();
      else start();
    }

    if (!document.hidden) start();
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      stop();
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [intervalMs]);

  return now;
}
